import axiosInstance from './axiosInstance';

const SALES_API_URL = '/sales';

const salesService = {
  async set(salesData) {
    try {
      const response = await axiosInstance.post(`${SALES_API_URL}/set.php`, salesData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar venda:', error);
      throw error;
    }
  }
};

export default salesService;

